// Shared landing-engine data: countries (region/currency/dial) + form options.

// name, dial code; region/currency resolved server-side (single source of truth there).
export const COUNTRIES = [
  ["Portugal", "+351", "PT"], ["Spain", "+34", "ES"], ["France", "+33", "FR"], ["Germany", "+49", "DE"],
  ["Italy", "+39", "IT"], ["Netherlands", "+31", "NL"], ["Belgium", "+32", "BE"], ["Luxembourg", "+352", "LU"],
  ["Austria", "+43", "AT"], ["Ireland", "+353", "IE"], ["United Kingdom", "+44", "GB"], ["Switzerland", "+41", "CH"],
  ["Norway", "+47", "NO"], ["Sweden", "+46", "SE"], ["Denmark", "+45", "DK"], ["Finland", "+358", "FI"],
  ["Poland", "+48", "PL"], ["Czech Republic", "+420", "CZ"], ["Slovakia", "+421", "SK"], ["Hungary", "+36", "HU"],
  ["Romania", "+40", "RO"], ["Bulgaria", "+359", "BG"], ["Greece", "+30", "GR"], ["Croatia", "+385", "HR"],
  ["Slovenia", "+386", "SI"], ["Estonia", "+372", "EE"], ["Latvia", "+371", "LV"], ["Lithuania", "+370", "LT"],
  ["Malta", "+356", "MT"], ["Cyprus", "+357", "CY"], ["Iceland", "+354", "IS"], ["Serbia", "+381", "RS"],
  ["Ukraine", "+380", "UA"], ["Turkey", "+90", "TR"], ["Morocco", "+212", "MA"], ["Algeria", "+213", "DZ"],
  ["Tunisia", "+216", "TN"], ["Egypt", "+20", "EG"], ["United States", "+1", "US"], ["Canada", "+1", "CA"],
  ["Mexico", "+52", "MX"], ["Brazil", "+55", "BR"], ["Argentina", "+54", "AR"], ["Chile", "+56", "CL"],
  ["Colombia", "+57", "CO"], ["Peru", "+51", "PE"], ["Uruguay", "+598", "UY"], ["Ecuador", "+593", "EC"],
  ["United Arab Emirates", "+971", "AE"], ["Saudi Arabia", "+966", "SA"], ["Qatar", "+974", "QA"],
  ["Kuwait", "+965", "KW"], ["Bahrain", "+973", "BH"], ["Oman", "+968", "OM"], ["Israel", "+972", "IL"],
  ["Jordan", "+962", "JO"], ["Lebanon", "+961", "LB"], ["South Africa", "+27", "ZA"], ["Nigeria", "+234", "NG"],
  ["Kenya", "+254", "KE"], ["Ghana", "+233", "GH"], ["Angola", "+244", "AO"], ["Mozambique", "+258", "MZ"],
  ["Mauritius", "+230", "MU"], ["Botswana", "+267", "BW"],
  ["China", "+86", "CN"], ["Hong Kong", "+852", "HK"], ["Singapore", "+65", "SG"], ["Japan", "+81", "JP"],
  ["South Korea", "+82", "KR"], ["India", "+91", "IN"], ["Indonesia", "+62", "ID"], ["Malaysia", "+60", "MY"],
  ["Thailand", "+66", "TH"], ["Vietnam", "+84", "VN"], ["Philippines", "+63", "PH"], ["Taiwan", "+886", "TW"],
  ["Australia", "+61", "AU"], ["New Zealand", "+64", "NZ"], ["Honduras", "+504", "HN"], ["Other", "", ""],
].map(([name, dial, iso2]) => ({ name, dial, iso2 }));

const CURRENCY_BY_LOCALE = { US: "USD", GB: "GBP", CH: "CHF", BR: "BRL", CA: "CAD", AU: "AUD" };

export const regionalCurrency = () => {
  try {
    const region = (navigator.language.split("-")[1] || "").toUpperCase();
    return CURRENCY_BY_LOCALE[region] || "EUR";
  } catch {
    return "EUR";
  }
};

export const PROJECT_TYPES = [
  { value: "commercial-gym", label: "Commercial Gym" },
  { value: "boutique-gym", label: "Boutique Gym" },
  { value: "pt-studio", label: "Personal Training Studio" },
  { value: "home-gym", label: "Private Home Gym" },
  { value: "residential-gym", label: "Residential / Condominium Gym" },
  { value: "hotel-resort", label: "Hotel / Resort Fitness Center" },
  { value: "corporate-gym", label: "Corporate Gym" },
  { value: "sports-facility", label: "Sports / Performance Facility" },
  { value: "franchise", label: "Gym Franchise / Franchise Location" },
  { value: "other", label: "Other" },
];

export const FRANCHISE_STATUS = [
  { value: "own-franchise", label: "Yes — I already own / operate a franchise" },
  { value: "acquiring-franchise", label: "Yes — I'm acquiring a franchise" },
  { value: "evaluating-franchise", label: "I'm evaluating franchise opportunities" },
  { value: "independent", label: "No — I'm exploring the fitness business independently" },
];

export const LOCATION_STATUS = [
  { value: "confirmed", label: "Yes — location confirmed" },
  { value: "negotiating", label: "Currently negotiating a location" },
  { value: "looking", label: "Still looking for a location" },
];

export const FACILITY_AREAS = [
  { value: "up-to-100", label: "Up to 100 m²" },
  { value: "100-250", label: "100–250 m²" },
  { value: "250-500", label: "250–500 m²" },
  { value: "500-1000", label: "500–1,000 m²" },
  { value: "1000-2000", label: "1,000–2,000 m²" },
  { value: "2000-plus", label: "2,000+ m²" },
];

export const PROJECT_STAGES = [
  { value: "exploring", label: "Exploring investment opportunities" },
  { value: "initial-planning", label: "Initial planning" },
  { value: "business-plan", label: "Business plan / Investment planning" },
  { value: "location-selected", label: "Location selected" },
  { value: "architecture", label: "Architecture / Design" },
  { value: "construction", label: "Construction / Renovation" },
  { value: "ready-to-purchase", label: "Ready to purchase equipment" },
  { value: "expansion", label: "Opening a new location / Expansion" },
];

export const OPENING_TIMELINES = [
  { value: "within-2", label: "Within 2 months" },
  { value: "2-4", label: "2–4 months" },
  { value: "4-6", label: "4–6 months" },
  { value: "6-12", label: "6–12 months" },
  { value: "12-plus", label: "12+ months" },
];

// Currency-neutral by design — this landing page serves multiple international markets.
export const INVESTMENT_BANDS = () => [
  { value: "up-to-50k", label: "Up to 50K" },
  { value: "50-150k", label: "50K–150K" },
  { value: "150-300k", label: "150K–300K" },
  { value: "300-500k", label: "300K–500K" },
  { value: "500k-1m", label: "500K–1M" },
  { value: "1m-plus", label: "1M+" },
];

export const PROJECT_NEEDS = [
  { value: "complete-equipment", label: "Complete Gym Equipment" },
  { value: "strength", label: "Strength Equipment" },
  { value: "cardio", label: "Cardio Equipment" },
  { value: "full-project-help", label: "I need help with the complete project" },
];

export const EQUIPMENT_LIST_STATUS = [
  { value: "have-list", label: "Yes — I already have a complete equipment list" },
  { value: "need-review", label: "Yes — but I need help reviewing it" },
  { value: "need-list", label: "No — I need help creating the equipment list" },
];

export const LOGISTICS_PREFS = [
  { value: "yanre-coordination", label: "I want YANRE logistics coordination" },
  { value: "own-partner", label: "I already have a logistics partner" },
  { value: "compare-both", label: "I would like to compare both options" },
  { value: "need-guidance", label: "I need guidance before deciding" },
];

export const PURCHASE_METHODS = [
  { value: "direct", label: "Direct from manufacturer" },
  { value: "dealer", label: "Local fitness equipment dealer" },
  { value: "distributor", label: "Distributor / Importer" },
  { value: "comparing", label: "Comparing different purchasing options" },
  { value: "researching", label: "Still researching suppliers" },
];

export const DECISION_ROLES = [
  { value: "owner", label: "Owner / Founder" },
  { value: "investor", label: "Investor" },
  { value: "partner", label: "Partner" },
  { value: "director", label: "Director / Executive" },
  { value: "manager", label: "Gym Manager" },
  { value: "procurement", label: "Procurement / Purchasing" },
  { value: "architect", label: "Architect / Designer" },
  { value: "consultant", label: "Consultant" },
  { value: "trainer", label: "Personal Trainer" },
  { value: "other", label: "Other" },
];

export const CONTACT_METHODS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "phone", label: "Phone Call" },
  { value: "email", label: "Email" },
];
